import { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './ShopResetPasswordPage.css';

function passwordStrength(pwd) {
  if (!pwd) return { level: 'empty', score: 0, label: '' };
  let score = 0;
  if (pwd.length >= 8) score++;
  if (pwd.length >= 12) score++;
  if (/[A-Z]/.test(pwd)) score++;
  if (/[0-9]/.test(pwd)) score++;
  if (/[^A-Za-z0-9]/.test(pwd)) score++;
  if (score <= 1) return { level: 'weak',   score, label: 'Zwak' };
  if (score <= 3) return { level: 'medium', score, label: 'Middel' };
  return { level: 'strong', score, label: 'Sterk' };
}

export default function ShopResetPasswordPage() {
  const navigate = useNavigate();
  const [pwd, setPwd] = useState('');
  const [pwd2, setPwd2] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const strength = useMemo(() => passwordStrength(pwd), [pwd]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (pwd.length < 8) {
      setError('Wachtwoord moet minimaal 8 tekens zijn');
      return;
    }
    if (pwd !== pwd2) {
      setError('Wachtwoorden komen niet overeen');
      return;
    }
    setError('');
    setSuccess(true);
  };

  if (success) {
    return (
      <div className="shop-rp">
        <div className="shop-rp__content">
          <div className="shop-rp__logo">
            <span className="shop-rp__logo-walk">Walk</span>
            <span className="shop-rp__logo-in">In</span>
          </div>
          <div className="shop-rp__success-icon">✅</div>
          <h2 className="shop-rp__title">Wachtwoord gewijzigd!</h2>
          <p className="shop-rp__sub">
            Je kunt nu inloggen met je nieuwe wachtwoord.
          </p>
          <button
            className="shop-rp__submit"
            onClick={() => navigate('/shop/login')}
          >
            Inloggen →
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="shop-rp">
      <div className="shop-rp__content">
        <div className="shop-rp__logo">
          <span className="shop-rp__logo-walk">Walk</span>
          <span className="shop-rp__logo-in">In</span>
        </div>
        <h1 className="shop-rp__title">Nieuw wachtwoord instellen</h1>

        <form className="shop-rp__form" onSubmit={handleSubmit}>
          <label className="shop-rp__field">
            <span className="shop-rp__label">Nieuw wachtwoord</span>
            <input
              type="password"
              className="shop-rp__input"
              value={pwd}
              onChange={(e) => { setPwd(e.target.value); setError(''); }}
              autoComplete="new-password"
              minLength={8}
              required
            />
            {pwd && (
              <div className={`shop-rp__strength shop-rp__strength--${strength.level}`}>
                <div className="shop-rp__strength-bar">
                  <div
                    className="shop-rp__strength-fill"
                    style={{ width: `${(strength.score / 5) * 100}%` }}
                  />
                </div>
                <span className="shop-rp__strength-label">{strength.label}</span>
              </div>
            )}
          </label>

          <label className="shop-rp__field">
            <span className="shop-rp__label">Bevestig wachtwoord</span>
            <input
              type="password"
              className="shop-rp__input"
              value={pwd2}
              onChange={(e) => { setPwd2(e.target.value); setError(''); }}
              autoComplete="new-password"
              minLength={8}
              required
            />
          </label>

          {error && <div className="shop-rp__err">{error}</div>}

          <button type="submit" className="shop-rp__submit">
            Stel nieuw wachtwoord in
          </button>
        </form>
      </div>
    </div>
  );
}
